import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    comparisonTableCellBase: {
        padding: '1rem 1.5rem',
        backgroundColor: defaultPalette.white.main,
        border: `0.5px solid ${defaultPalette.lightGrey.mediumDark}`,
        borderTopColor: 'transparent',
        borderLeftColor: 'transparent',
        color: defaultPalette.typography.main,
        '&:last-child': {
            borderRightColor: 'transparent',
        },
    },
    comparisonTableCellHeader: {
        backgroundColor: defaultPalette.lightGrey.ultraLight,
        '& .MuiTypography-root': {
            fontWeight: 700,
        },
    },
    comparisonTableCellPrevious: {
        backgroundColor: defaultPalette.orange.ultraLight,
        color: defaultPalette.orange.dark,
    },
    comparisonTableCellNew: {
        backgroundColor: defaultPalette.green.ultraVeryLight,
        color: defaultPalette.green.dark,
    },
    comparisonTableCellError: {
        backgroundColor: defaultPalette.red.ultraVeryLight,
        color: defaultPalette.error.main,
    },
    comparisonTableCellHelperText: {
        fontSize: '0.75rem',
    },
})
